import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
// import CheckBox from '~/componentes/CustomForm/Check/styles/CheckBox';

import { Container } from './styles';
// import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
// import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
// import Acoordion from '~/componentes/Acoordion';
// import Button from '~/componentes/Button';
import IconLixeira from '~/assets/icones/IconLixeira.svg';
import ShowError from '~/utils/ShowError';

function CreateContent({ mountedData }) {
  const [clientes, setClientes] = useState([]);
  const [projetos, setProjetos] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [ordemServicoAtividades, setOrdemServicoAtividades] = useState([]);
  const [gmudList, setGmudList] = useState([]);
  const { perfil } = useSelector(state => state.auth);

  function formatDate(dateString) {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  async function fetchGmuds() {
    try {
      const responseAnalista = await api.get('/signed/empresa/gestorprojeto/gerencia/analistas');
      const perfilAnalista = responseAnalista.data.find(a => a.idPerfil === perfil.idPerfil);

      const params = {
        idEmpresa: perfil.idEmpresa,
        idUnidade: perfil.idUnidade,
        idPerfil: perfilAnalista?.perfil?.usuario?.id,
        status: 'concluida',
      };

      const response = await api.get('/signed/empresa/gestorprojeto/gmud', { params });
      const dataFormatted = response.data.map(item => ({
        ...item,
        dataSolicitacao: formatDate(item.dataSolicitacao),
        dataHoraInicio: formatDate(item.dataHoraInicio),
        dataHoraFim: formatDate(item.dataHoraFim),
      }));

      setGmudList(dataFormatted);
    } catch (error) {
      console.error('Erro ao buscar GMUDs:', error);
    }
  }

  useEffect(() => {
    if (perfil?.idPerfil && perfil?.idEmpresa && perfil?.idUnidade) {
      fetchGmuds();
    }
  }, [perfil?.idPerfil, perfil?.idEmpresa, perfil?.idUnidade]);

  useEffect(() => {
    let lista = [];
    let listaHor = [];
    let count = 1;
    for (let itemAtv of mountedData?.atividades) {
      lista.push(itemAtv);

      for (const itemAtivo of itemAtv?.horarios) {
        listaHor.push({
          id: count,
          titulo: 'º Horário',
          horaInicial: itemAtivo?.horaInicial,
          horaFinal: itemAtivo?.horaFinal,
          idProjetoAtividade: itemAtv?.idProjetoAtividade,
        });

        count++;
      }
    }
    setOrdemServicoAtividades(lista);

    setHorarios(listaHor);

    setClientes([mountedData?.cliente]);
    setProjetos([mountedData?.projeto]);
  }, [mountedData]);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    if (
      !data.dataEmissao ||
      !data.titulo ||
      !data.idCliente ||
      !data.idProjeto ||
      ordemServicoAtividades.length === 0 ||
      horarios.length === 0 ||
      horarios.some(h => !h.horaInicial || !h.horaFinal || !h.idProjetoAtividade)
    ) {
      ShowError('Preencha todos os campos obrigatórios antes de salvar a Ordem de Serviço.');
      return;
    }

    return ShowConfirmacao(
      async () => {
        const idGmud = data.idGmud ? parseInt(data.idGmud, 10) : null;
        let thisData = {
          ...data,
          idGmud: idGmud,
          horarios,
          id: mountedData?.id,
          atividades: ordemServicoAtividades,
        };

        let response = await api.put('/signed/empresa/gestorprojeto/ordemservico', thisData);
        if (response?.status === 200) {
          closeReload && closeReload();
        }

        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao cadastrar essa Ordem de Serviço, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja cadastrar essa Ordem de Serviço?`,
        successModal: `Ordem de Serviço cadastrada com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios
          </p>
        </div>
        <div className="row">
          <div className="col s8 m8 l8">
            <div className="row">
              <Label title="Data *" className="col s6 m4 l3">
                <Input
                  type="date"
                  name="dataEmissao"
                  required="true"
                  defaultValue={mountedData?.dataEmissao}
                  min={mountedData?.atividades[0].projetoAtividade?.previsaoInicio}
                  max={mountedData?.atividades[0].projetoAtividade?.previsaoEntrega}
                />
              </Label>
              <Label title="Título *" className="col s6 m8 l9">
                <Input name="titulo" required="true" defaultValue={mountedData?.titulo} />
              </Label>
            </div>
            <div className="row no-margin">
              <Label title="Cliente *" className="col s4 m4 l4">
                <Select
                  required="true"
                  isString
                  list={{
                    list: clientes,
                    value: 'id',
                    label: 'nomeFantasia',
                  }}
                  name="idCliente"
                  defaultValue={mountedData?.idCliente}
                />
              </Label>
              <Label title="Projeto *" className="col s4 m4 l4">
                <Select
                  required="true"
                  isString
                  list={{
                    list: projetos,
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="idProjeto"
                  defaultValue={mountedData?.idProjeto}
                />
              </Label>
              <Label title="Desconto" className="col s2 m2 l2">
                <Select
                  isString
                  list={{
                    list: [
                      { id: '00:00', titulo: '00:00' },
                      { id: '00:15', titulo: '00:15' },
                      { id: '00:30', titulo: '00:30' },
                      { id: '00:45', titulo: '00:45' },
                      { id: '01:00', titulo: '01:00' },
                      { id: '01:15', titulo: '01:15' },
                      { id: '01:30', titulo: '01:30' },
                      { id: '01:45', titulo: '01:45' },
                      { id: '02:00', titulo: '02:00' },
                      { id: '02:15', titulo: '02:15' },
                      { id: '02:30', titulo: '02:30' },
                      { id: '02:45', titulo: '02:45' },
                      { id: '03:00', titulo: '03:00' },
                      { id: '03:15', titulo: '03:15' },
                      { id: '03:30', titulo: '03:30' },
                      { id: '03:45', titulo: '03:45' },
                      { id: '04:00', titulo: '04:00' },
                      { id: '04:15', titulo: '04:15' },
                      { id: '04:30', titulo: '04:30' },
                      { id: '04:45', titulo: '04:45' },
                      { id: '05:00', titulo: '05:00' },
                      { id: '05:15', titulo: '05:15' },
                      { id: '05:30', titulo: '05:30' },
                      { id: '05:45', titulo: '05:45' },
                      { id: '06:00', titulo: '06:00' },
                      { id: '06:15', titulo: '06:15' },
                      { id: '06:30', titulo: '06:30' },
                      { id: '06:45', titulo: '06:45' },
                      { id: '07:00', titulo: '07:00' },
                      { id: '07:15', titulo: '07:15' },
                      { id: '07:30', titulo: '07:30' },
                      { id: '07:45', titulo: '07:45' },
                      { id: '08:00', titulo: '08:00' },
                      { id: '08:15', titulo: '08:15' },
                      { id: '08:30', titulo: '08:30' },
                      { id: '08:45', titulo: '08:45' },
                      { id: '09:00', titulo: '09:00' },
                      { id: '09:15', titulo: '09:15' },
                      { id: '09:30', titulo: '09:30' },
                      { id: '09:45', titulo: '09:45' },
                      { id: '10:00', titulo: '10:00' },
                      { id: '10:15', titulo: '10:15' },
                      { id: '10:30', titulo: '10:30' },
                      { id: '10:45', titulo: '10:45' },
                      { id: '11:00', titulo: '11:00' },
                      { id: '11:15', titulo: '11:15' },
                      { id: '11:30', titulo: '11:30' },
                      { id: '11:45', titulo: '11:45' },
                      { id: '12:00', titulo: '12:00' },
                      { id: '12:15', titulo: '12:15' },
                      { id: '12:30', titulo: '12:30' },
                      { id: '12:45', titulo: '12:45' },
                      { id: '13:00', titulo: '13:00' },
                      { id: '13:15', titulo: '13:15' },
                      { id: '13:30', titulo: '13:30' },
                      { id: '13:45', titulo: '13:45' },
                      { id: '14:00', titulo: '14:00' },
                      { id: '14:15', titulo: '14:15' },
                      { id: '14:30', titulo: '14:30' },
                      { id: '14:45', titulo: '14:45' },
                      { id: '15:00', titulo: '15:00' },
                      { id: '15:15', titulo: '15:15' },
                      { id: '15:30', titulo: '15:30' },
                      { id: '15:45', titulo: '15:45' },
                      { id: '16:00', titulo: '16:00' },
                      { id: '16:15', titulo: '16:15' },
                      { id: '16:30', titulo: '16:30' },
                      { id: '16:45', titulo: '16:45' },
                      { id: '17:00', titulo: '17:00' },
                      { id: '17:15', titulo: '17:15' },
                      { id: '17:30', titulo: '17:30' },
                      { id: '17:45', titulo: '17:45' },
                      { id: '18:00', titulo: '18:00' },
                      { id: '18:15', titulo: '18:15' },
                      { id: '18:30', titulo: '18:30' },
                      { id: '18:45', titulo: '18:45' },
                      { id: '19:00', titulo: '19:00' },
                      { id: '19:15', titulo: '19:15' },
                      { id: '19:30', titulo: '19:30' },
                      { id: '19:45', titulo: '19:45' },
                      { id: '20:00', titulo: '20:00' },
                      { id: '20:15', titulo: '20:15' },
                      { id: '20:30', titulo: '20:30' },
                      { id: '20:45', titulo: '20:45' },
                      { id: '21:00', titulo: '21:00' },
                      { id: '21:15', titulo: '21:15' },
                      { id: '21:30', titulo: '21:30' },
                      { id: '21:45', titulo: '18:45' },
                      { id: '22:00', titulo: '22:00' },
                      { id: '22:15', titulo: '22:15' },
                      { id: '22:30', titulo: '22:30' },
                      { id: '22:45', titulo: '22:45' },
                      { id: '23:00', titulo: '23:00' },
                      { id: '23:15', titulo: '23:15' },
                      { id: '23:30', titulo: '23:30' },
                      { id: '23:45', titulo: '23:45' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="horaDesconto"
                  defaultValue={mountedData?.horaDescontoMascara}
                />
              </Label>
              <Label title="Translado" className="col s2 m2 l2">
                <Select
                  isString
                  list={{
                    list: [
                      { id: '00:00', titulo: '00:00' },
                      { id: '00:15', titulo: '00:15' },
                      { id: '00:30', titulo: '00:30' },
                      { id: '00:45', titulo: '00:45' },
                      { id: '01:00', titulo: '01:00' },
                      { id: '01:15', titulo: '01:15' },
                      { id: '01:30', titulo: '01:30' },
                      { id: '01:45', titulo: '01:45' },
                      { id: '02:00', titulo: '02:00' },
                      { id: '02:15', titulo: '02:15' },
                      { id: '02:30', titulo: '02:30' },
                      { id: '02:45', titulo: '02:45' },
                      { id: '03:00', titulo: '03:00' },
                      { id: '03:15', titulo: '03:15' },
                      { id: '03:30', titulo: '03:30' },
                      { id: '03:45', titulo: '03:45' },
                      { id: '04:00', titulo: '04:00' },
                      { id: '04:15', titulo: '04:15' },
                      { id: '04:30', titulo: '04:30' },
                      { id: '04:45', titulo: '04:45' },
                      { id: '05:00', titulo: '05:00' },
                      { id: '05:15', titulo: '05:15' },
                      { id: '05:30', titulo: '05:30' },
                      { id: '05:45', titulo: '05:45' },
                      { id: '06:00', titulo: '06:00' },
                      { id: '06:15', titulo: '06:15' },
                      { id: '06:30', titulo: '06:30' },
                      { id: '06:45', titulo: '06:45' },
                      { id: '07:00', titulo: '07:00' },
                      { id: '07:15', titulo: '07:15' },
                      { id: '07:30', titulo: '07:30' },
                      { id: '07:45', titulo: '07:45' },
                      { id: '08:00', titulo: '08:00' },
                      { id: '08:15', titulo: '08:15' },
                      { id: '08:30', titulo: '08:30' },
                      { id: '08:45', titulo: '08:45' },
                      { id: '09:00', titulo: '09:00' },
                      { id: '09:15', titulo: '09:15' },
                      { id: '09:30', titulo: '09:30' },
                      { id: '09:45', titulo: '09:45' },
                      { id: '10:00', titulo: '10:00' },
                      { id: '10:15', titulo: '10:15' },
                      { id: '10:30', titulo: '10:30' },
                      { id: '10:45', titulo: '10:45' },
                      { id: '11:00', titulo: '11:00' },
                      { id: '11:15', titulo: '11:15' },
                      { id: '11:30', titulo: '11:30' },
                      { id: '11:45', titulo: '11:45' },
                      { id: '12:00', titulo: '12:00' },
                      { id: '12:15', titulo: '12:15' },
                      { id: '12:30', titulo: '12:30' },
                      { id: '12:45', titulo: '12:45' },
                      { id: '13:00', titulo: '13:00' },
                      { id: '13:15', titulo: '13:15' },
                      { id: '13:30', titulo: '13:30' },
                      { id: '13:45', titulo: '13:45' },
                      { id: '14:00', titulo: '14:00' },
                      { id: '14:15', titulo: '14:15' },
                      { id: '14:30', titulo: '14:30' },
                      { id: '14:45', titulo: '14:45' },
                      { id: '15:00', titulo: '15:00' },
                      { id: '15:15', titulo: '15:15' },
                      { id: '15:30', titulo: '15:30' },
                      { id: '15:45', titulo: '15:45' },
                      { id: '16:00', titulo: '16:00' },
                      { id: '16:15', titulo: '16:15' },
                      { id: '16:30', titulo: '16:30' },
                      { id: '16:45', titulo: '16:45' },
                      { id: '17:00', titulo: '17:00' },
                      { id: '17:15', titulo: '17:15' },
                      { id: '17:30', titulo: '17:30' },
                      { id: '17:45', titulo: '17:45' },
                      { id: '18:00', titulo: '18:00' },
                      { id: '18:15', titulo: '18:15' },
                      { id: '18:30', titulo: '18:30' },
                      { id: '18:45', titulo: '18:45' },
                      { id: '19:00', titulo: '19:00' },
                      { id: '19:15', titulo: '19:15' },
                      { id: '19:30', titulo: '19:30' },
                      { id: '19:45', titulo: '19:45' },
                      { id: '20:00', titulo: '20:00' },
                      { id: '20:15', titulo: '20:15' },
                      { id: '20:30', titulo: '20:30' },
                      { id: '20:45', titulo: '20:45' },
                      { id: '21:00', titulo: '21:00' },
                      { id: '21:15', titulo: '21:15' },
                      { id: '21:30', titulo: '21:30' },
                      { id: '21:45', titulo: '18:45' },
                      { id: '22:00', titulo: '22:00' },
                      { id: '22:15', titulo: '22:15' },
                      { id: '22:30', titulo: '22:30' },
                      { id: '22:45', titulo: '22:45' },
                      { id: '23:00', titulo: '23:00' },
                      { id: '23:15', titulo: '23:15' },
                      { id: '23:30', titulo: '23:30' },
                      { id: '23:45', titulo: '23:45' },
                    ],
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="horaTranslado"
                  defaultValue={mountedData?.horaTransladoMascara}
                />
              </Label>

              <Label title="Selecione GMUD" className="col s6 m6 l6" style={{ maxWidth: '300px' }}>
                <Select
                  isString
                  list={{
                    list: gmudList,
                    value: 'id',
                    label: 'titulo',
                  }}
                  name="idGmud"
                  firstOption
                  defaultValue={mountedData?.idGmud}
                />
              </Label>
            </div>
            <div className="row no-margin">
              <Label title="Observação de Aprovado/Reprovado" className="col s12 m12 l12">
                <TextArea
                  name="observacaoAprovDesaprov"
                  required="false"
                  defaultValue={mountedData?.observacao}
                  readOnly="true"
                />
              </Label>
            </div>
            <div className="row">
              <div className="col s12 m12 l12">
                <p className="title_p">Atividades *</p>
                <div className="content-atividade">
                  {ordemServicoAtividades?.map((item, index) => (
                    <div className="atv-content" key={index}>
                      <div className="atv-content-top">
                        <div className="card-titulo">
                          <p className="titulo">
                            {item?.id} - {item?.titulo}
                          </p>
                        </div>
                        <div className="card-check checked">
                          <span />
                        </div>
                      </div>
                      <div className="atv-content-body">
                        <Label title="Descrição *" className="col s12 m12 l12">
                          <TextArea
                            name="descricao"
                            required="false"
                            defaultValue={item?.descricao}
                            onChange={e => {
                              const v = e.currentTarget.value || '';

                              let lista = [];
                              for (const itemAtivo of ordemServicoAtividades) {
                                if (itemAtivo?.id == item?.id) {
                                  lista.push({ ...itemAtivo, descricao: v });
                                } else {
                                  lista.push(itemAtivo);
                                }
                              }

                              setOrdemServicoAtividades(lista);
                            }}
                          />
                        </Label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col s4 m4 l4">
            <p className="title_p">Horários *</p>
            <div className="row-left">
              <div className="col s12 m12 l12">
                {horarios &&
                  horarios?.map(item => (
                    <div className="content" key={item?.id}>
                      <div className="content-top">
                        <div className="card-cod">
                          <p className="cod">
                            {item?.id} {item?.titulo}
                          </p>
                        </div>
                        <img
                          src={IconLixeira}
                          alt="lixeira"
                          onClick={() => {
                            if (horarios.length > 1) {
                              const itemFind = horarios?.find(d => d?.id == item?.id);
                              let lista = [];
                              for (let itemHor of horarios) {
                                if (itemFind?.id != itemHor?.id) {
                                  lista.push(itemHor);
                                }
                              }
                              setHorarios(lista);
                            }
                          }}
                        />
                      </div>
                      <div className="content-body">
                        <Label title="Atividade *" className="col s12 m12 l12">
                          <Select
                            isString
                            list={{
                              list: ordemServicoAtividades,
                              value: 'idProjetoAtividade',
                              label: 'titulo',
                            }}
                            name="idProjetoAtividade"
                            value={item?.idProjetoAtividade}
                            onChange={e => {
                              const v = e.currentTarget.value || 0;

                              let lista = [];
                              for (const itemAtivo of horarios) {
                                if (itemAtivo?.id == item?.id) {
                                  lista.push({ ...itemAtivo, idProjetoAtividade: v });
                                } else {
                                  lista.push(itemAtivo);
                                }
                              }

                              setHorarios(lista);
                            }}
                          />
                        </Label>
                        <Label title="Hora Inicial *" className="col s6 m6 l6">
                          <Input
                            type="time"
                            name="horaInicial"
                            required="true"
                            value={item?.horaInicial}
                            onChange={e => {
                              const v = e.currentTarget.value || '00:00';

                              let lista = [];
                              for (const itemAtivo of horarios) {
                                if (itemAtivo?.id == item?.id) {
                                  lista.push({ ...itemAtivo, horaInicial: v });
                                } else {
                                  lista.push(itemAtivo);
                                }
                              }

                              setHorarios(lista);
                            }}
                          />
                        </Label>
                        <Label title="Hora Final *" className="col s6 m6 l6">
                          <Input
                            type="time"
                            name="horaFinal"
                            required="true"
                            value={item?.horaFinal}
                            onChange={e => {
                              const v = e.currentTarget.value || '';

                              let lista = [];
                              for (const itemAtivo of horarios) {
                                if (itemAtivo?.id == item?.id) {
                                  lista.push({ ...itemAtivo, horaFinal: v });
                                } else {
                                  lista.push(itemAtivo);
                                }
                              }

                              setHorarios(lista);
                            }}
                          />
                        </Label>
                      </div>
                    </div>
                  ))}
              </div>
              <div
                className="novo-horario"
                onClick={() => {
                  let lista = [];
                  for (const itemHor of horarios) {
                    lista.push(itemHor);
                  }

                  lista.push({
                    id: horarios[horarios.length - 1]?.id + 1,
                    titulo: 'º Horário',
                    horaInicial: '08:00',
                    horaFinal: '12:00',
                    idProjetoAtividade:
                      ordemServicoAtividades?.length > 0
                        ? ordemServicoAtividades[0]?.idProjetoAtividade
                        : 0,
                  });
                  setHorarios(lista);
                }}
              >
                <p className="adiciona-horario">Adicionar</p>
              </div>
            </div>
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateContent;
